// The latest API includes INP (FID was retired). Publish measurements locally;
// an approved telemetry consumer can subscribe to upstrive:performance.
const record = metric => {
    window.__UPSTRIVE_VITALS__ = { ...window.__UPSTRIVE_VITALS__, [metric.name]: metric }
    window.dispatchEvent(new CustomEvent('upstrive:performance', { detail: metric }))
}

export default function reportWebVitals(onPerfEntry = record) {
    import('web-vitals').then(({ onCLS, onINP, onFCP, onLCP, onTTFB }) => {
        onCLS(onPerfEntry); onINP(onPerfEntry); onFCP(onPerfEntry); onLCP(onPerfEntry); onTTFB(onPerfEntry)
    }).catch(error => console.warn('Performance measurement unavailable:', error))
}
